/* eslint-disable max-len */
import React, {Component} from 'react';
import {graphql} from 'react-apollo';
import {autobind} from 'core-decorators';
import userQuery from 'graphql/queries/user.gql';
import termsAndConditionsQuery from 'graphql/queries/terms-and-conditions.gql';
import acceptTermsAndConditionsMutation from 'graphql/mutations/users/accept-terms-and-conditions.gql';
import Popup from 'components/popup';
import Spinner from 'components/spinner';
import Button from 'components/button';
import SectionTitle from 'components/section-title';
import TermsAndConditionsText from 'components/terms-and-conditions-text';
import styles from './styles.css';

@graphql(termsAndConditionsQuery)
@graphql(acceptTermsAndConditionsMutation, {
    props: ({mutate}) => ({
        acceptTermsAndConditions: () => mutate({
            refetchQueries: [{
                query: userQuery,
            }],
        }),
    }),
})
@autobind
export default class TermsAndConditionsPopup extends Component {
    state = {
        loading: false,
        visible: true,
    };

    async handleSubmit() {
        this.setState({loading: true});
        await this.props.acceptTermsAndConditions();
        this.setState({loading: false, visible: false});
    }

    render() {
        return (
            <Popup visible={this.state.visible}>
                <div className={styles.root}>
                    <SectionTitle title='Bases y condiciones' subtitle='Las bases y condiciones del portal fueron actualizadas. Para continuar usando el portal de marketing tenés que aceptar las nuevas bases y condiciones.' />
                    <div className={styles.container}>
                        {this.props.data.termsAndConditions
                            ? <TermsAndConditionsText data={this.props.data.termsAndConditions} />
                            : <Spinner />
                        }
                    </div>
                    <div className={styles.button}>
                        <Button
                            type='button'
                            theme='yellow'
                            disabled={this.state.loading}
                            onClick={this.handleSubmit}>
                            {this.state.loading ? 'GUARDANDO...' : 'ACEPTAR BASES Y CONDICIONES'}
                        </Button>
                    </div>
                </div>
            </Popup>
        );
    }
}



// WEBPACK FOOTER //
// ./components/terms-and-conditions-popup/index.js